import type { ModuleOptions } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import React from "react";

export const module: ModuleOptions = {
  resource: ResourceEnum.Category,
  bigIcon: <i className={"icon-20-categories"} />,
  smallIcon: <i className={"icon-15-categories"} />,
};
